module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "Badge0.b9170eb2.png";